import '../../styles/hero.css';

const Hero = () => {
  return (
    <section id='hero'>
      <h1>Discover the world on wheels with our car rental service</h1>
    </section>
  );
};

export default Hero;
